import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EmailSettings} from "../../../../../../_models/notificationSettings";

@Component({
  selector: 'app-elements-email-notification-settings',
  templateUrl: './elements-email-notification-settings.component.html',
  styleUrls: ['./elements-email-notification-settings.component.scss']
})
export class ElementsEmailNotificationSettingsComponent {
    @Input() settings: EmailSettings;
    @Output() toggleSetting: EventEmitter<any> = new EventEmitter();
}
